import { SearchRequest } from '@empathy/search-adapter';
import { Filter, RelatedTag } from '@empathy/search-types';
import { distinctUntilChanged } from 'rxjs/operators/distinctUntilChanged';
import { Dictionary } from '../../utils';

const primitiveRequestProperties: Exclude<keyof SearchRequest, 'relatedTags' | 'filters'>[] = [
  'query',
  'rows',
  'sort',
  'start',
  'origin'
];

export function hasNewSearchRequest() {
  return distinctUntilChanged(areSearchRequestsEqual);
}

export function areSearchRequestsEqual(lastRequest: SearchRequest, newRequest: SearchRequest): boolean {
  // The point of negating the entire statement is to  being able to use the "some" loop instead of the "every"
  // so we can get a better performance in this comparison
  return !(anySearchRequestPrimitiveIsDifferent(lastRequest, newRequest)
    || anyFilterIsDifferent(lastRequest.filters, newRequest.filters)
    || anyRelatedTagIsDifferent(lastRequest.relatedTags, newRequest.relatedTags));
}

function anySearchRequestPrimitiveIsDifferent(oldRequest: SearchRequest, newRequest: SearchRequest): boolean {
  return primitiveRequestProperties.some(prop => oldRequest[prop] !== newRequest[prop]);
}

function anyRelatedTagIsDifferent(oldRelatedTags: RelatedTag[], newRelatedTags: RelatedTag[]): boolean {
  return oldRelatedTags.length !== newRelatedTags.length
    || oldRelatedTags.some(oldRT => !newRelatedTags.find(newRT => newRT.tag === oldRT.tag));
}

function anyFilterIsDifferent(oldSelectedFilters: Dictionary<Filter[]>, newSelectedFilters: Dictionary<Filter[]>): boolean {
  const oldFilters = filtersDictionaryToArray(oldSelectedFilters);
  const newFilters = filtersDictionaryToArray(newSelectedFilters);

  return oldFilters.length !== newFilters.length
    || oldFilters.some(oldFilter => !newFilters.find(newFilter => oldFilter.id === newFilter.id));
}

function filtersDictionaryToArray(filtersDictionary: Dictionary<Filter[]>): Filter[] {
  return Object.values(filtersDictionary).reduce((filtersArray, filter) => {
    filtersArray.push(...filter);
    return filtersArray;
  }, []);
}
